var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "complete_content",
      attrs: { id: "new_account" },
      on: {
        click: function($event) {
          _vm.closeMenu()
        }
      }
    },
    [
      _c("dd-header", { ref: "menuRef", attrs: { headerType: 2 } }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: { pageKey: _vm.pageKey, pageList: _vm.pageList }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { attrs: { id: "regist_btn" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "detail_btn6 btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.goEdit()
                        }
                      }
                    },
                    [_vm._v("編集画面に戻る")]
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("メールアドレス更新完了")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("ul", { staticClass: "thanks" }, [
        _c("li", [_vm._v("メールアドレスを更新が完了しました。")]),
        _vm._v(" "),
        _c("li", [_vm._v("引き続き、mm/styleをご利用ください。")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e679a5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e679a5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcUpdateAccountComplete.vue
// module id = null
// module chunks = 